export default {
  placeholder: 'Name des Restaurants eingeben',
  labels: {
    cant_find_place: 'Ort nicht in der Liste?',
    reset_categories: 'Ortskategorien zurücksetzen',
  },
};
